export const tradingContest = {
  cyjyds: "Participate in the trading competition",
  jsjxmh: "Unlock the surprise blind box and win super prizes",
  hdsj: "Activity time",
  mrjxsj: "Conducted from 00:00 to 23:59 UTC+8 every day.",
  ckxxgz: "Detailed rules",
  wdjj: "My bonus",
  jlkj: "Count Down",
  cjjc: "Super prize pool",
  jjmrzj: "Bonuses will increase daily",
  kqxjd: "Open a new stage and the number of rewards will increase",
  dyjd: "Stage 1",
  dejd: "Stage 2",
  dsjd: "Stage 3",
  dsijd: "Stage 4",
  jrmhjj: "Today’s blind box bonus",
  syjj: "Remaining bonus",
  yblqje: "Amount received",
  tjmh: "Special box",
  yjmh: "1 level box",
  ejmh: "2 level box",
  sjmh: "3 level box",
  jj: "Bonus: ",
  gs: "piece",
  djdkrymh: "Click to open a surprise blind box",
  kydk: "You can open it today",
  jxmh: "Shocking Mystic Box",
  dkmhxyxx: "It takes {amount} stars to open a box. ",
  xzyyxx: "You have {amount} stars now",
  xxqlsj: "Stars clearing time: {date} （Please go and open boxs before the stars clear）",
  wdxx: "my star",
  xxhq: "Star acquisition",
  hqxxtj: "How to get stars",
  yxhysxf: "Perpetual Contract: Earn 1 star for every {amount}U of handling fees",
  qqhysxf: "Options contracts: Earn 1 star for every {amount}U of trading volume",
  youxihysxf: "GameFi: Earn 1 star for every {amount}U of transaction volume",
  gxhd: "Congratulations, you have got",
  jlydrzh: "The bonus has been credited to your '{account}'",
  qzjzhck: "Go to the Gamefi account to view",
  bwcjjc: "Biking Super Prize Pool ",
  qmxjyds: "All-Star Trading Competition",
  gbgbyb: "Dare you give it a try?",
  bwcjjcdnn: "Biking super prize pool, {amount}% of the blind box prize for you every day!",
  cjjcqmxjys: "{amount}% of the prize pool of the Biking Super Prize Pool All-Star Trading Competition is added to the blind box every day.",
  syyxbd: "Open it and win with a small amount!",
  zgtk: "Want to reach the top? Come and fight!",
  zhyz: "{amount}% of the daily prize pool is accumulated until the final battle.",
  dfdj: " Who can win the top prize of the Biking?",
  gsjj: "The masters of the Biking Super Prize Pool",
  qmxpk: "All-Star Trading Competition gather together to see the real results of the All-Star PK!",
  jymh: "Trading, blind box, ranking, and have fun in the Biking Arena!",
  zzbzy: "Perpetual contracts, options, GameFi, spot trading, the surrounding gameplay is upgraded layer by layer, and it is never the same every week!",
  jlfh: "Biking Super Prize Pool All-Star Trading Competition, generous rewards are waiting for you to gain fame and fortune and become the hero!",
  mh: "Blind box",
  cb: "Ranking",
  jy: "Trading",
  syxxs: "Remaining stars number",
  xxbhs: "Changed stars number",
  sjlx: "event type",
  jycp: "Trading products",
  jye: "Transaction volume",
  myxgjl: "You have not received any relevant rewards yet",
  jyhd: "Transaction obtained",
  ql: "Clear",
  kqmh: "Open blind box",
  yx: "GameFi",
  bchdyjs: "This event has ended",
  gffjj: "Total Prizes",
  kqmhsl: "Opened boxes number",
  cjjcjj: "Super prize pool bonus",
  cjjchjmd: "Super prize pool winners list",
  jjdyyh: "The bonus has been credited to the user’s fund account",
  hdjj: "Get bonus",
  wff: "Undistributed",
  mhhjjl: "Blind Box Award",
  cjdjhjjl: "Super Grand Prize",
  jjse: "Bonus amount",
  xhxxs: "Consumed stars number",
  bwqmxgz: "Biking All-Star Trading Competition Rules",
  hdnr: "Activity content",
  hdnrgz: "The Biking Super Prize Pool All-Star Trading Competition covers four major areas: perpetual contracts, options contracts, GameFi games and spot trading. The event is divided into four weeks, and new trading products are gradually unlocked every week, allowing you to obtain 'stars' in multi-dimensional trading challenges and win generous rewards. {total}% of the daily prize pool is used for blind box draws, and surprise rewards are available immediately! The remaining {amount}% will be accumulated until the end of the competition, and the highest reward will be divided according to transaction ranking!",
  hdjd: "Activity stage",
  jbjs: "Gradually unlock, four stage of competition upgrades",
  dyzq: "Stage1",
  kqyxhy: "Enable perpetual contract trading. The higher the trading volume, the more star points and the higher the prize pool rewards!",
  dezq: "Stage2",
  jmqqjy: "Increase options contract trading, and gain a two-way jackpot for profit and loss, allowing you to upgrade your number of stars again.",
  dszq: "Stage3",
  cjgejc: "Join the GameFi game, earn stars through diverse trading experiences, and hit the high prize pool.",
  dsizq: "Stage4",
  gfzzdj: "The blind box prize pool will continue to be open in the first three weeks, and the spot trading list will be set up separately to share the final prize!",
  jzszjs: "Prize pool prize calculation",
  jxmhgz1: "Every day, {amount}% of the goods are distributed to blind boxes, 100 blind boxes are immediately opened, and four kinds of goods are delivered at the same time. Not yet collected. Encouraging self-development has arrived the next day, and the profits have increased! Special grade blind boxes, first grade blind boxes, etc. are updated every day, and the super-high middle-order rate etc. are coming!",
  mhfpmx: "The number of blind boxes is {total} per day, and the number of blind boxes is {amount}%. Blind box distribution details:",
  tjmhzb: "{total} special quality blind box, share ratio {amount}% Prize pool",
  yjmhzb: "{total} first-level blind boxes, accounting for {amount}% of the prize pool",
  ejmhzb: "{total} secondary blind boxes, accounting for {amount}% of the prize pool",
  sjmhzb: "{total} third-level blind boxes, accounting for {amount}% of the prize pool",
  kmhxxyq: "Opening box demand star quantity requirement: Every day blind box opening/{text}",
  tips: "Note: 0 items are updated every day when the book is opened, and the amount of money that is added to the amount of money that has been opened in the previous day is calculated.",
  mrjyyk: "The total prize pool is based on daily trading profits and losses in the three major sectors of perpetual contracts, options contracts, and GameFi.",
  mgyld: "{amount}% of each profit order = profit amount * {amount}%",
  mrjcljdjs: "{amount}% of the daily prize pool will be accumulated until the end of the event, and will be divided among the top three in the rankings of the four major trading products. The proportions of the continued prize pool are: 40% for perpetual contracts, 30% for options, 20% for GameFi, and 10% for spot products.",
  yhhyyld: "For example: if the user’s contract order profit is 1000U, then 1000*{amount}%={total}U will enter the day’s prize pool",
  mgksd: "{amount}% of each loss order = actual loss amount (loss - liquidation) * {amount}%",
  yhhyks: "For example: if the user's contract order actually loses 1000U, then 1000*{amount}%={total}U will enter the day's prize pool.",
  qqhyyld: "{amount}% of each profit order = bet amount * odds * {amount}%",
  qqyhddtz: "For example: if a user bets 100U on an option order and makes a profit in a 10-second period, then 100*65%*{amount}%={total}U will enter the day’s prize pool.",
  qqhyksd: "{amount}% of each loss order = loss amount * {amount}%",
  yhksjrjc: "For example: if the user's option order loss is 100U, then 100*{amount}%={total}U will enter the day's prize pool.",
  yxyld: "{amount}% of each profit order = bet amount * odds * {amount}%",
  yxddtz: "For example: User gamefi order bets 100U, assuming the odds are 2 times. If you make a profit, 100*200%*{amount}%={total}U will enter the day’s prize pool.",
  yxmgksd: "{amount}% of each loss order = loss amount * {amount}%",
  yhqqksd: "For example: if the user's option order loss is 100U, then 100*{amount}%={total}U will enter the day's prize pool.",
  daiding: "To be determined",
  yytz: "Activity Adjustment",
  kaiqi: "Open",
  xhjyjrpm: "Spot trading joins the ranking",
  drjy: "Trade on the same day and receive the next day",

}


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/en.js